<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="线上订单 > 临时订单列表" style="height:auto" >
      <el-form :inline="true" :model="orderForm" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input size="mini" v-model.trim="orderForm.orderNo" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="data"
        size="small"
        height="695"
        border>
        <el-table-column
          fixed
          prop="orderNo"
          label="订单编号"
          show-overflow-tooltip
          width="195">
        </el-table-column>
        <el-table-column
          fixed
          prop="createDate"
          show-overflow-tooltip
          label="下单时间"
          width="146">
        </el-table-column>
        <el-table-column
          prop="moblie"
          label="用户名"
          show-overflow-tooltip
          width="100">
        </el-table-column>
        <el-table-column
          prop="manufacturerNumber"
          show-overflow-tooltip
          label="产品型号"
          width="200">
        </el-table-column>
        <el-table-column
          prop="brandName"
          label="品牌名称"
          width="140">
        </el-table-column>
        <el-table-column
          prop="count"
          label="购买数量"
          width="90">
        </el-table-column>
        <el-table-column
          prop="originalPrice"
          label="购买价格"
          width="110">
        </el-table-column>
        <el-table-column
          prop="originalAmount"
          label="商品总金额"
          width="110">
        </el-table-column>
        <el-table-column
            prop="bdSource"
            show-overflow-tooltip
            width="90"
            label="用户来源">
          </el-table-column>
        <el-table-column
          prop="ipAddress"
          show-overflow-tooltip
          label="IP所在地">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="left" v-if="scope.row.orderStatus != -1 && scope.row.orderStatus != -3">
              <p>IP: {{ scope.row.ip }}</p>
              <p>ip所在地: {{ scope.row.ipAddress }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.ipAddress }}</el-tag>
              </div>
            </el-popover>
            <span v-else>{{ scope.row.totalAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          show-overflow-tooltip
          label="备注"
          width="80">
        </el-table-column>
        <el-table-column
          prop="linkUserName"
          label="客服接待"
          width="90">
        </el-table-column>
        <el-table-column
          fixed="right"
          width="90"
          label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="scope.row.linkUserId == null"
              @click="linkCustomer(scope.row)">关联客服</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      orderForm: {
        orderNo: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      orderNos: '',
    };
  },
  components: {
    pagination
  },
  methods: {
    getOrderData: function() {
      this.optionItem = this.common.extend(this.orderForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/temp/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data;
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getOrderData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getOrderData()
    },
    linkCustomer: function(val) {
      // 判断该订单下是否存在需要发货的字订单
      this.http.post(
      '/user/link/customer', 
      {
        id: val.userId,
        token: this.user.getToken()
      }, res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    }
  },
  mounted: function() {
    this.getOrderData()
  },
};
</script>


<style>
.invoice-css {
  padding: 10px 0 20px 0; width: 60%; text-align:center;
}
.el-table th {
  background: #F5F7FA;
}
.el-table__expanded-cell {  
  padding: 0px 0px 15px 47px !important;
}
.el-tabs {
  border:1px solid #eee;
}
.el-tabs__nav {
  padding: 0 20px;
}
.el-tabs__active-bar {
  margin-left: 20px;
}
.el-input--suffix .el-input__inner {
  padding-right: 16px;
}

.demo-table-expand {
  font-size: 0;
}
.el-form-item__content {
  line-height: none;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.el-table .success-refund{
  background: #FFF;
}
.el-table .success-paid{
  background:#FFF;
}

.el-table .success-over {
  background: #f5f7fa;
}
.el-table .cell {
  line-height: 24px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/views/order/temp/tempOrderList.vue